<template>
  <v-row no-gutters>
    <v-col v-if="products && selected.length <= MAX_LENGTH - 1" cols="12" class="pb-6">
      <Select
        v-model="selected"
        placeholder="Escolha os ingressos"
        label="Selecione os ingressos"
        multiple
        :items="getProducts"
        :menu-props="{closeOnContentClick: selected.length === MAX_LENGTH, maxHeight: 300}"
        :disabled="selected.length === MAX_LENGTH"
        itemText="text"
        returnObject
        :showBorder="true"
        useSelectionTemplate
        useItemTemplate
      >
        <template v-slot:selection="{index}">
          <span v-if="index === 0">{{selected.length}} selecionados</span>
        </template>

        <template v-slot:item="{ item, attrs }">
          <div class="d-flex py-2" style="width: 200px; z-index: 10">
            <div style="position: relative; z-index: 1 !important">
              <div style="position: absolute; width: 100%; height: 100%; z-index: 100"></div>
              <Checkbox v-model="attrs.inputValue" :id="attrs.id"/>
            </div>
            <div class="pl-3" style="font-size: 0.9rem">{{item.nome_tipo ? `${item.nome} - ${item.nome_tipo}` : item.nome}}</div>
          </div>
        </template>
      </Select>
    </v-col>

    <v-col v-if="selected.length > 0" cols="12">
      <span class="d-block _subtitleFormFont pb-2"><b>Ingressos selecionados:</b></span>
      <draggable ghost-class="ghost" :list="selected">
        <transition-group type="transition" name="list-complete"> 
          <div v-for="(ticket, index) in selected" :key="index" class="style-row show-cursor bgHover" no-gutters>
            <section class="d-flex flex-column mb-2">
              <div class="styles-item">
                <v-icon size="16">fa-regular fa-ticket</v-icon>
                <span class="d-block ticket-title">{{ticket.text}}</span>
                <div class="d-flex flex justify-end">
                  <DeleteButton @click="handleDelete(selected, index)"/>       
                </div>
              </div>   
            </section>             
          </div>            
        </transition-group>
      </draggable>      
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseObject } from '../../../../../schemas'
import { TICKETS_LAYOUT_SELECTED_ITEMS } from '../../../../../schemas/sections'
import draggable from 'vuedraggable'
import Select from '../../../../_v2/ui/Select.vue'
import DeleteButton from '../../../../_v2/ui/DeleteButton.vue'
import Checkbox from '../../../../_v2/ui/Checkbox/Checkbox.vue'

export default {
  name: 'newLayoutSelect',
  components: {Select, draggable, DeleteButton, Checkbox},
  props: {
    selectedSection: {type: Object, required: true}
  },

  computed: {
    ...mapGetters(['products']),
    getProducts () {
      if (this.products) return this.products.products.map(item => ({...item, text: item.nome_tipo ? `${item.nome} - ${item.nome_tipo}` : item.nome}))
      else return []
    }
  },

  mounted () {
    this.loadData()
  },

  data: () => ({
    MAX_LENGTH: 4,
    selected: []
  }),

  methods: {
    handleDelete(options, index) {
      options.splice(index, 1)
    },

    loadData() {
      if (this.selectedSection.itemsV2 && this.selectedSection.itemsV2.length > 0) {
        this.selectedSection.itemsV2.forEach(item => {
          const check = this.getProducts.find(product => product.codigo_produto === item.codigo && product.codigo_tipo === item.codigo_tipo)
          if (check) this.selected.push({...check, ...item})
        })
      }
    }
  },

  watch: {
    products: {
      deep: true,
      handler () {
        this.loadData()
      }
    },

    selected: {
      deep: true,
      handler (v) {
        const copy = JSON.parse(JSON.stringify(v))
        const parsedArray = copy.map(item => {
          const target = {...item, codigo: item.codigo_produto}
          const getCurrentTicket = this.selectedSection.itemsV2.find(ticket => ticket.codigo === target.codigo && ticket.codigo_tipo === target.codigo_tipo)

          if (getCurrentTicket) {
            target.destaque = getCurrentTicket.destaque
            target.itens_incluidos = getCurrentTicket.itens_incluidos
          }

          return {...parseObject({schema: TICKETS_LAYOUT_SELECTED_ITEMS(), target})}
        })
        
        this.selectedSection.itemsV2 = parsedArray
      }
    }
  }    
}
</script>

<style scoped>
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
    cursor: move !important
  }

  .styles-item {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    max-width: 100% !important;
    height: 50px;
    align-items: center;
    font-size: 0.9rem;
    transition: all 0.3s;
    padding: 0 8px 0 8px;
    border-radius: 4px;
    overflow: hidden;
    white-space: nowrap;
  }

  .styles-item span {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;  
  }

  .styles-item:hover {
    cursor: pointer;
    animation: changeCursor 3s forwards;
  }

  .show-cursor {
    cursor: move !important;
    transition: all 0.3s;    
  }

  .ticket-title {
    word-break: break-all !important;
    word-wrap: break-word !important;
    max-width: 200px !important;
  }

  .show-cursor:hover {
    border-radius: 4px;
  }

  .bgHover:hover {
    background-color: #FAFBFB;    
  }

  @keyframes changeCursor {
    100% {
      cursor: move;
    }
  }

  .list-complete-item {
    transition: all 0.8s;
    display: inline-block;
    margin-right: 10px;
  }

  .list-complete-enter, .list-complete-leave-to {
    opacity: 0;
    transform: translateY(-30px);
  }

  .list-complete-leave-active {
    position: absolute;
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
  }  
</style>